import { PapiComment, PapiDeviation } from '@wix/da-papi-types';
import { BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
import { DeviationResourceType } from '../types/deviation';
import { ResourceType } from '../types/resource';
import { NotificationQueueItem } from '../Notifications';
import { CoreBadgeRecipient } from './types';

export function getRecipientSectionName(typeId: number) {
  let sectionName;
  if (DeviationResourceType[typeId]) {
    sectionName = 'deviation';
  } else if (typeId === ResourceType.COMMENT) {
    sectionName = 'comments';
  } else {
    sectionName = BiContextProvidedValue;
  }
  return sectionName;
}

export function getRecipientForDeviation(
  deviation: PapiDeviation
): CoreBadgeRecipient {
  return {
    typeId: getDeviationResourceType(deviation),
    itemId: deviation.deviationId,
    user: deviation.author!,
  };
}

export function getRecipientForComment(
  comment: PapiComment
): CoreBadgeRecipient {
  return {
    comment,
    typeId: ResourceType.COMMENT,
    itemId: comment.commentId,
    user: comment.user,
  };
}

export const badgeNotificationsFilter =
  (badgeName: string) => (notification: NotificationQueueItem) =>
    notification.params?.badge?.name === badgeName;
